import { useMemo } from "react";
import intl from "react-intl-universal";
import {
  buildBaasWalletStablesAsset,
  formatBaasStablesNetworkLabel,
  resolveBaasWalletChainId,
} from "../../../../../Services/baasStablesWalletApi";
import { StablesDepositarContent } from "../../../Stables/StablesDepositarContent";

/**
 * Admin deposit panel: same IB deposit UI, bound to the selected wallet
 * (asset/network/address locked — no client deposit APIs).
 */
export const BaasStablesDepositPanel = ({ wallet, marketQuotes = [] }) => {
  const asset = useMemo(
    () => (wallet ? buildBaasWalletStablesAsset(wallet, marketQuotes) : null),
    [wallet, marketQuotes],
  );

  const assetsOverride = useMemo(() => (asset ? [asset] : []), [asset]);

  const networksOverride = useMemo(() => {
    if (!wallet) return [];
    const id = resolveBaasWalletChainId(wallet);
    return [{ id, label: formatBaasStablesNetworkLabel(wallet.network) || wallet.network || id }];
  }, [wallet]);

  if (!wallet) {
    return (
      <section className="app-card app-empty-state">
        <p>{intl.get("baas.stables.operation.selectWalletFirst")}</p>
      </section>
    );
  }

  if (wallet.status && wallet.status !== "active") {
    return (
      <section className="app-card app-empty-state">
        <p>{intl.get("baas.stables.operation.walletInactive", { status: wallet.status })}</p>
      </section>
    );
  }

  if (!asset) return null;

  return (
    <section className="app-card mb-6 p-4 sm:p-5">
      <StablesDepositarContent
        isActive
        assetsOverride={assetsOverride}
        networksOverride={networksOverride}
        addressOverride={wallet.address ?? ""}
        lockSelectors
        introMessage={intl.get("baas.stables.operation.deposit.intro")}
        emptyAddressMessage={intl.get("baas.stables.operation.deposit.noAddress", {
          asset: wallet.asset,
          network: wallet.network,
        })}
      />
    </section>
  );
};
